import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { transformErrorResponse } from "src/store/helpers";
import { PaginatedResponse } from "src/types";

import { toBackendPageIndex } from "@shared/table/Tanstack.utils";

import { AdminBuilder } from "./tags";

export type AdminFileSortCriteria =
    "filename" | "fileSize" | "modifiedDate" | "sourceType" | "ownerId" | "workspaceId" | "groupId";

export type GetAdminFilesParams = {
    fileName?: string;
    workspaceId?: number;
    pageIndex: number;
    pageSize: number;
    sortCriteria: AdminFileSortCriteria;
    sortDirection: "asc" | "desc";
};

const files = (builder: AdminBuilder) => ({
    getAdminFiles: builder.query<PaginatedResponse<API.File>, GetAdminFilesParams>({
        providesTags: ["AdminFiles"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        query: async (payload) => {
            const base = await RouteService.getStorageRoute();
            return {
                url: `${base}files/all`,
                params: { ...payload, pageIndex: toBackendPageIndex(payload.pageIndex) },
            };
        },
    }),
});

export default files;
